import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef} from '@angular/core';
import { ActivatedRoute, Params, Router  } from '@angular/router';
import { Subscription ,  Observable ,  Subject } from 'rxjs';

import { ApiGatewayHelperService } from './../../../app/services/apigateway-helper.service';
import { ActivityViewDataService } from './../../services/activity-view-data.service';
import { ActivityViewHelperService } from './../../services/activity-view-helper.service';
import { CanComponentDeactivate } from './../../services/can-deactivate-lp-guard.service';
import { LoaderService } from '../../../app/services/loader.service';
import { AppHelperService } from 'modules/app/services/app-helper.service';
import { AuthService } from 'modules/app/services/auth.service';
import { ActivityRenderer } from '../activity-renderer/activity-renderer.component';
import { GroupHelperService } from 'modules/shared/services/groups-helper.service';
import { CustomBackendLoggerService } from 'modules/app/services/custom-backend-logger.service';
import { ContentHelper } from 'libs-content-helper';
import { TrackUserService } from './../../../shared/services/track-user.service';

@Component({
    selector: 'activity-view',
    templateUrl: './activity-view.template.html',
    styleUrls: ['./activity-view.style.scss'],
    standalone: false
})
export class ActivityView implements OnInit, CanComponentDeactivate {
    isTeacher: boolean;
    productTocData: any;
    tocArray: any;
    assignmentData: any;
    selectedAssignmentItems:any = [];
    paramsSubscription: Subscription;
    spaceId: string;
    productCode: string;
    classId: string;
    assignmentId: string;
    productMeta: any;
    selectedItemSubscription: Subscription;
    selectedItem : any = {};
    selectedItemData : any = {};
    xapiLOAnalytics: any;
    previewMode : string;
    appState: any;
    userProfileData: any;
    bundleDetails : any;
    showResultScreenEvent:Subject<any> = new Subject();


    /* Boolean to show/hide result screen */
    showResultScreen: boolean = false;
    
    /* Array to contain all the content controls visible */
    showControls = [];
    /* Boolean to show/hide next activity button */
    showNextActivityBtn: boolean = false;
    /* Boolean to determine if current selected activity is game - needed to hide header and controls */
    isGameActivity: boolean = false;

    @ViewChild('launchNextActivityBtn',  { static: true }) launchNextActivity : ElementRef;
    @ViewChild(ActivityRenderer,  { static: true }) private activityRenderer : ActivityRenderer;
    
    constructor(
        private route: ActivatedRoute, 
        private router: Router,
        private activityViewHelperService: ActivityViewHelperService,
        private loaderService: LoaderService,
        private appHelperService: AppHelperService,
        private apiGatewayHelperService : ApiGatewayHelperService, 
        private activityViewDataService : ActivityViewDataService,
        private chRef: ChangeDetectorRef,
        private authService: AuthService,
        private groupHelperService: GroupHelperService,
        private trackUserService: TrackUserService,
        private customBackendLoggerService: CustomBackendLoggerService,
        ) { }

    ngOnInit() {
        this.previewMode = this.route.snapshot.queryParamMap.get('preview');
        this.authService.logoutTriggered.subscribe(() => {
            // Removed xapiLOAnalytics object so that no analytics call is made when user is leaves activity-view component
            this.xapiLOAnalytics = undefined;
        });
        if (this.previewMode || (this.router.url && this.router.url.indexOf("/teacher/") !== -1) ) {
            this.isTeacher = true;
            this.activityViewHelperService.setIsTeacher(true);
        } else {
            this.isTeacher = false;
            this.activityViewHelperService.setIsTeacher(false);
        }

         // Product TOC data
        this.productTocData = this.route.snapshot.data.activityViewResolverData.productData; 
        this.userProfileData = this.route.snapshot.data.activityViewResolverData.userProfileData;      
        this.paramsSubscription = this.route.params.subscribe((params: Params) => {
            // CLear previous TOC data
            this.spaceId = params.spaceId;
            this.productCode = params.productCode;
            this.classId = params.classId;
            this.assignmentId = params.assignmentId;

            // Make classId undefined if Class is expired, so that the component behaves like it does with private learning
            if(this.productTocData && this.productTocData.classDetails && this.productTocData.classDetails.class && this.productTocData.classDetails.class.enddate && new Date(this.productTocData.classDetails.class.enddate) < new Date()) {
                this.classId = undefined;
            }

            this.tocArray = this.productTocData.toc.tocArray;
            this.productMeta = this.productTocData.productDetails.meta;
            this.bundleDetails = this.productTocData.bundleDetails;
            this.appState = this.productTocData.appState;

            if(params.assignmentId) {
                this.assignmentData = this.productTocData.assignmentData.entities[0];                 
                this.selectedAssignmentItems = [];
                this.assignmentData.items.reduce((accumulator, currentValue)=> {
                    if(!currentValue.invalid) {
                        accumulator.push(currentValue['item-code'])
                    }
                    return accumulator;
                }, this.selectedAssignmentItems);
                this.productTocData.toc.navigationMeta = this.productTocData.toc.navigationMeta.filter((item)=> {
                    return this.selectedAssignmentItems.includes(item["item-code"]); 
                })
            }
        

            this.activityViewHelperService.setProductClass(this.spaceId, this.productCode, params.classId, this.productTocData.classDetails ? this.productTocData.classDetails.class : {});
            
            //Fetch bundle product
            const bundleProduct = this.bundleDetails.products.find((product) => product['dls-product'].code === this.productCode);

            //ANALYTICS - Setup initialization params & initialize analytics engine.
            const routePrefix = this.apiGatewayHelperService.getApiGatewayPrefixUrl();
            const serverRoutePrefix = routePrefix.substring(0, routePrefix.length-1);

            //Setup initialization params
            var initParams = {  
                paths: {
                    dependencyBase: window.location.protocol + '//' + window.location.host + MICROAPP_BASE_URL + 'node_modules',
                    contentAssetBase: this.productMeta.paths["public-assets"]
                },
                serverRoutePrefix: !this.isTeacher && serverRoutePrefix,
                userId: this.userProfileData.extUserId,
                userRole: this.userProfileData.role,
                userFirstName: this.userProfileData.firstName,
                productCode: this.productCode,
                isTestTypeProduct: this.activityViewHelperService.getIsTestTypeProduct(),
                spaceId : this.spaceId,
                classId: this.classId,
                isCBPClass: this.activityViewHelperService.getIsCBPClass(),
                segment : this.userProfileData.role === 'student' && bundleProduct.segment ? bundleProduct.segment.segment : 'adult'
            };
            let xapiAnalyticsOptions = {
                    serverRoutePrefix: serverRoutePrefix ,
                    dlsProductCode: this.productCode, 
                    isTestTypeProduct: this.activityViewHelperService.getIsTestTypeProduct(),
                    spaceId : this.spaceId,
                    orgId: this.productTocData.toc.tocArray.orgId,
                    dlsClassId: this.classId,
                    isCBPClass: this.activityViewHelperService.getIsCBPClass(),
                    dlsAssignmentId: this.assignmentId,
                    userId: this.userProfileData.extUserId,
                    userProgressAnalytics: this.productTocData.toc.navigationMeta,
            }
            this.activityViewHelperService.setXAPIAnalyticsObject(xapiAnalyticsOptions);

            //Setup event handlers for receiving events from LO.
            this.xapiLOAnalytics = this.activityViewHelperService.getXAPIAnalyticsObject();
            var eventCallbacks = {                
                newState: (uniqueId, newState) => {
                    //Persist state to LRS via analytics engine if user is not a teacher
                    if (this.xapiLOAnalytics && !this.isTeacher) {
                        this.xapiLOAnalytics.postState(uniqueId, newState);
                    }
                },
                newInterpretedStatements: (uniqueId, newInterpretedStatements) => {
                    // Ignore statements in case user is a teacher
                    if (this.isTeacher) {
                        return;
                    }
                    var unitId = this.selectedItem.unitId;
                    var lessonId = this.selectedItem.lessonId;
                    var activityId = this.selectedItem.activityId;
                    var courseToc = this.productTocData.toc.tocObject;
                    var verb;
                    var groupId;

                    let foundCompletedStatement = false;

                    try {

                        for(var i=0; i < newInterpretedStatements.length; i++) {
                            if(newInterpretedStatements[i].json && newInterpretedStatements[i].json.verb && newInterpretedStatements[i].json.verb.id ) {
                                verb = newInterpretedStatements[i].json.verb.id;
                                if(newInterpretedStatements[i].json && newInterpretedStatements[i].json.group) {
                                    groupId = newInterpretedStatements[i].json.group.id;
                                }
                                if (verb.indexOf("launched") !== -1) {              
                                    this.activityViewHelperService.addActivityTiming(activityId, 'launchTs',
                                        new Date(newInterpretedStatements[i].json.timestamp).getTime());
                                    if (newInterpretedStatements[i].json.object && newInterpretedStatements[i].json.object.id && newInterpretedStatements[i].json.object.id !== activityId) {
                                    // If launched statement of previous LO is called after the user has changed the LO, ignore that status
                                        return;
                                    }                  
                                    if (unitId && lessonId && activityId) {
                                        if (!courseToc[unitId].items[lessonId].items[activityId].__analytics.accessedOnce) {
                                            courseToc[unitId].items[lessonId].items[activityId].__analytics.accessedOnce = true;
                                        }

                                        if (courseToc[unitId].items[lessonId].items[activityId].__analytics.status != 'in_complete') {
                                            this.tocArray.__analytics.itemsCount.inComplete++;
                                            if (courseToc[unitId].items[lessonId].items[activityId].__analytics.status == 'completed') {
                                                this.tocArray.__analytics.itemsCount.completed--;
                                            }
                                        }
                                        
                                        courseToc[unitId].items[lessonId].items[activityId].__analytics.status = 'in_complete';
                                        if(!this.assignmentId) {
                                            this.appState.recentlyAccessedItem = activityId;
                                            this.activityViewDataService.updateAppState(this.spaceId, this.productCode, this.appState, params.classId).subscribe();
                                        }
                                    }
                                } else if (verb.indexOf("completed") !== -1) {
                                    this.logInfoToBackend('TYPE=ACTIVITY_COMPLETION;MicroAPP');
                                    foundCompletedStatement = true;
                                    if (newInterpretedStatements[i].json.object && newInterpretedStatements[i].json.object.id && newInterpretedStatements[i].json.object.id !== activityId) {
                                        // If completed statement of previous LO is called after the user has changed the LO, ignore that status
                                        this.activityViewHelperService.addActivityTiming(newInterpretedStatements[i].json.object.id, 'completeTs',
                                            new Date(newInterpretedStatements[i].json.timestamp).getTime());
                                        this.logInfoToBackend('TYPE=ACTIVITY_COMPLETION_ERROR;MicroAPP', {
                                            newInterpretedStatements,
                                            statementIndexWithWrongId: i,
                                            timings: this.activityViewHelperService.getActivityTiming(newInterpretedStatements[i].json.object.id),
                                        });
                                        // Clean up the item timing map
                                        this.activityViewHelperService.deleteActivityTiming(newInterpretedStatements[i].json.object.id);
                                        return;
                                    }
                                    // Clean up the item timing map
                                    this.activityViewHelperService.deleteActivityTiming(newInterpretedStatements[i].json.object.id);
                                    if (unitId && lessonId && activityId) {
                                        this.tocArray.__analytics.itemsCount.completed++;
                                        this.tocArray.__analytics.itemsCount.inComplete--;
                                        
                                        courseToc[unitId].items[lessonId].items[activityId].__analytics.status = 'completed';
                                        if (courseToc[unitId].items[lessonId].items[activityId]["sub-type"] === "ext-cup-xapiscoreable") {
                                            if (courseToc[unitId].items[lessonId].items[activityId].__analytics.bestResult) {
                                                if (courseToc[unitId].items[lessonId].items[activityId].__analytics.bestResult.scaledScore !== undefined) {
                                                    if (newInterpretedStatements[i].json.result.score.scaled > courseToc[unitId].items[lessonId].items[activityId].__analytics.bestResult.scaledScore) {
                                                        courseToc[unitId].items[lessonId].items[activityId].__analytics.bestResult.scaledScore = newInterpretedStatements[i].json.result.score.scaled;
                                                        courseToc[unitId].items[lessonId].items[activityId].__analytics.bestResult.min = newInterpretedStatements[i].json.result.score.min;
                                                        courseToc[unitId].items[lessonId].items[activityId].__analytics.bestResult.max = newInterpretedStatements[i].json.result.score.max;
                                                        courseToc[unitId].items[lessonId].items[activityId].__analytics.bestResult.raw = newInterpretedStatements[i].json.result.score.raw;
                                                    }
                                                } else {
                                                    courseToc[unitId].items[lessonId].items[activityId].__analytics.bestResult.scaledScore = newInterpretedStatements[i].json.result.score.scaled;
                                                    courseToc[unitId].items[lessonId].items[activityId].__analytics.bestResult.min = newInterpretedStatements[i].json.result.score.min;
                                                    courseToc[unitId].items[lessonId].items[activityId].__analytics.bestResult.max = newInterpretedStatements[i].json.result.score.max;
                                                    courseToc[unitId].items[lessonId].items[activityId].__analytics.bestResult.raw = newInterpretedStatements[i].json.result.score.raw;
                                                }
                                                
                                            } else {
                                                courseToc[unitId].items[lessonId].items[activityId].__analytics.bestResult = { 
                                                    scaledScore: newInterpretedStatements[i].json.result.score.scaled,
                                                    min: newInterpretedStatements[i].json.result.score.min,
                                                    max: newInterpretedStatements[i].json.result.score.max,
                                                    raw: newInterpretedStatements[i].json.result.score.raw
                                                };
                                            }
                                            if (!courseToc[unitId].items[lessonId].items[activityId].__analytics.firstResult) courseToc[unitId].items[lessonId].items[activityId].__analytics.firstResult = {};
                                            if (courseToc[unitId].items[lessonId].items[activityId].__analytics.firstResult.scaledScore === undefined) {
                                                courseToc[unitId].items[lessonId].items[activityId].__analytics.firstResult.scaledScore = courseToc[unitId].items[lessonId].items[activityId].__analytics.bestResult.scaledScore;
                                                courseToc[unitId].items[lessonId].items[activityId].__analytics.firstResult.min = courseToc[unitId].items[lessonId].items[activityId].__analytics.bestResult.min;
                                                courseToc[unitId].items[lessonId].items[activityId].__analytics.firstResult.max = courseToc[unitId].items[lessonId].items[activityId].__analytics.bestResult.max;
                                                courseToc[unitId].items[lessonId].items[activityId].__analytics.firstResult.raw = courseToc[unitId].items[lessonId].items[activityId].__analytics.bestResult.raw;
                                            }
                                        }

                                        if (!courseToc[unitId].items[lessonId].items[activityId].__analytics.completedOnce) {
                                            courseToc[unitId].items[lessonId].items[activityId].__analytics.completedOnce = true;
                                            if (courseToc[unitId].items[lessonId].items[activityId]['contributes-to-completion'] !== false) {
                                                // Updated Lesson level Analytics
                                                courseToc[unitId].items[lessonId].__analytics.itemCounts.completedAndContributeCompletion++;
                                                // Updated Unit level Analytics
                                                courseToc[unitId].__analytics.itemCounts.completedAndContributeCompletion++;
                                            }
                                        }
                                        
                                        if (!courseToc[unitId].items[lessonId].items[activityId].__analytics.completedOnceWithSuccess && !ContentHelper.isTestContent(courseToc[unitId].items[lessonId].items[activityId])) {
                                            courseToc[unitId].items[lessonId].items[activityId].__analytics.completedOnceWithSuccess = true;
                                            if (courseToc[unitId].items[lessonId].items[activityId]['contributes-to-completion'] !== false) {
                                                // Updated Lesson level Analytics
                                                courseToc[unitId].items[lessonId].__analytics.itemCounts.completedWithSuccessAndContributeCompletion++;
                                                // Updated Unit level Analytics
                                                courseToc[unitId].__analytics.itemCounts.completedWithSuccessAndContributeCompletion++;
                                            }
                                        } 
                                        //Update completedOnceWithSucess if it is not present AND teacherScore is also missing 
                                        else if (!courseToc[unitId].items[lessonId].items[activityId].__analytics.completedOnceWithSuccess &&
                                                 !courseToc[unitId].items[lessonId].items[activityId].__analytics.evaluationOverride &&
                                                 courseToc[unitId].items[lessonId].items[activityId]["sub-type"] == "ext-cup-xapiscoreable" &&
                                                 newInterpretedStatements[i].json.result && newInterpretedStatements[i].json.result.score &&
                                                 newInterpretedStatements[i].json.result.score.hasOwnProperty('scaled')) {
                                            if (newInterpretedStatements[i].json.result.score.scaled >= courseToc[unitId].items[lessonId].items[activityId]["pass-score"]) {
                                                courseToc[unitId].items[lessonId].items[activityId].__analytics.completedOnceWithSuccess = true;
                                                if (courseToc[unitId].items[lessonId].items[activityId]['contributes-to-completion'] !== false) {
                                                    // Updated Lesson level Analytics
                                                    courseToc[unitId].items[lessonId].__analytics.itemCounts.completedWithSuccessAndContributeCompletion++;
                                                    courseToc[unitId].items[lessonId].__analytics.itemCounts.completedWithSuccessTestAndContributeCompletion ++;
                                                    // Updated Unit level Analytics
                                                    courseToc[unitId].__analytics.itemCounts.completedWithSuccessAndContributeCompletion++;
                                                    courseToc[unitId].__analytics.itemCounts.completedWithSuccessTestAndContributeCompletion++;
                                                }
                                            }                                    
                                        }
                                    }
                                } else if (verb.indexOf("submitted") !== -1) {
                                    if (newInterpretedStatements[i].json.object && newInterpretedStatements[i].json.object.id && newInterpretedStatements[i].json.object.id !== activityId) {
                                        // If completed statement of previous LO is called after the user has changed the LO, ignore that status
                                        return;
                                    }
                                }
                                // Update the icon object
                                if (unitId && lessonId && activityId) {
                                    this.updateLCHObjects(courseToc[unitId].items[lessonId].items[activityId])
                                    if(!this.chRef['destroyed']) {
                                        this.chRef.detectChanges();
                                    }
                                }
                            }
                        }
                        //Post Statements to LRS via analytics engine if user is not a teacher
                        if (this.xapiLOAnalytics && !this.isTeacher) {
                            if (verb && (verb.indexOf("submitted") !== -1 || (verb.indexOf("completed") !== -1  && groupId))) {
                                // In case of submitted verb sent from pskill activities do not batch the calls
                                let options = {};
                                if(this.selectedItemData?.['sub-type'] === 'cup-pskill' && this.selectedItemData[this.selectedItemData['sub-type']]['cup-options'].submissionType.id === 'speak' ) {
                                options = {
                                    isSignedURLReq:  true,
                                    subType: 'cup-pskill',
                                    submissionTypeId: 'speak'
                                }
                            }
                                this.xapiLOAnalytics.postStatementsNoBatch(newInterpretedStatements, options).then((response)=> {
                                    this.showOrHideNextActivityButton();
                                    if(verb.indexOf("submitted") !== -1) {
                                        let formattedAnalyticData = this._getpSkillFormattedAnalyticData(response, courseToc);
                                        this.activityViewHelperService.pskillAnsSaved.next(formattedAnalyticData);
                                    } else {
                                        this.activityViewHelperService.completeCollabActivity.next(response);
                                    }
                                }, (error)=> {
                                    if (error.responseJSON && error.responseJSON.errorCode === 'LINK_ERROR') {
                                        this.activityViewHelperService.pskillUrlLinkValidation.next(error);
                                        return;
                                    }
                                    this.activityViewHelperService.changesNotSaved.next();
                                });
                            } else if(verb && verb.indexOf("submitted") === -1) {
                                this.xapiLOAnalytics.postStatements(newInterpretedStatements);
                            }
                        }

                    } catch (error) {
                        if (foundCompletedStatement) {
                            const localStorageInfo = this.analyzeLocalStorage(error);
                            this.logInfoToBackend('TYPE=ACTIVITY_COMPLETION_ERROR;MicroAPP', {
                                newInterpretedStatements,
                                ...localStorageInfo,
                                timings: this.activityViewHelperService.getActivityTiming(activityId),
                                errorMessage: error.message,
                                errorStack: error.stack,
                                errorObject: JSON.stringify(error)
                            });
                        }
                        throw error;
                    }
                },
                containerNotification: (uniqueId, containerEvent, containerEventData) => {
                    // These events are needed in SPA LOs for Progress Bar
                    const activityEventsToBePassed = ['container_controls', 'currentScreen', 'totalScreens', 'activityClosed'];
                    if (this.selectedItemData && this.selectedItemData[this.selectedItemData["sub-type"]] && this.selectedItemData[this.selectedItemData["sub-type"]].container === 'spa-container') {
                        if (activityEventsToBePassed.indexOf(containerEvent) > -1) {
                            this.activityViewHelperService.activityEventsSubject.next({uniqueId, containerEvent, containerEventData});
                        }
                    }
                    if (containerEvent === 'avallain_controls' || containerEvent === 'generic_controls') {
                        if(containerEventData.state) {
                            let isControlAlreadyExist = this.showControls.findIndex((control) => {
                                return control.type === containerEventData.control;
                            });
                            if (isControlAlreadyExist === -1) {
                                /* Show Button */
                                let controlData = {
                                    'containerType': containerEvent,
                                    'type': containerEventData.control,
                                    'text': containerEventData.meta.buttonText,
                                };
                                /* set translations keys for the hardcoded buttons text that we get from xapirunner*/
                                switch(controlData.text) {
                                    case 'Check': controlData.text = 'TEACHER.ACTIVITYVIEW.CHECK'; break;
                                    case 'Next' : controlData.text = 'TEACHER.ACTIVITYVIEW.NEXT'; break;
                                    case 'Review' : controlData.text = 'TEACHER.ACTIVITYVIEW.REVIEW'; break;
                                    case 'Previous' : controlData.text = 'TEACHER.ACTIVITYVIEW.PREVIOUS'; break;
                                }
                                /* Previous button to be shown first always and next button to be shown at the right most end always */
                                if(controlData.type === 'goPrev') this.showControls.unshift(controlData);
                                else if(controlData.type === 'goNext') this.showControls.push(controlData);
                                else {
                                    const goNextIndex = this.showControls.findIndex((control) => {
                                        return control.type === 'goNext';
                                    });
                                    if(goNextIndex !== -1) {
                                        this.showControls.splice(goNextIndex, 0, controlData);
                                    } else {
                                        this.showControls.push(controlData);
                                    }
                                }
                            }
                        } else {
                            /* Hide Button */
                            this.showControls = this.showControls.filter((control) => { 
                                return control.type !== containerEventData.control;
                            });
                        }
                    } else if (containerEvent === 'container_controls') {
                        if (containerEventData === 'activityCompleted') {
                            this.showOrHideNextActivityButton();
                        }
                    } else if (containerEvent === 'activityClosed') {
                        // hide C1 result screen if rendered
                        this.hideResultScreen();
                        /*launch next activity or Show TOC (for games) if content terminates itself
                        ignore activityClosed event if close called by conatiner (logout, navigate to dashboard and click on 'tryAgain' button scenarios) */
                        if (!containerEventData.isContainerCloseCalled && uniqueId === this.selectedItem.activityId) {
                            if (this.isGameActivity) {
                                this.activityRenderer.closeActivityBtn.nativeElement.click();
                            } else {
                                this.launchNextActivity.nativeElement.click();
                            }
                        }
                    } else if (containerEvent === 'showResults') {
                        this.showResultScreenEvent.next(containerEventData);
                        this.showResultScreen = true;
                    }	                    
                    if(!this.chRef['destroyed'])
                        this.chRef.detectChanges();
                }
            }
            // Initialize the Activity & setup event handlers.
            this.activityViewHelperService.setXAPIRunnerObject(initParams, eventCallbacks);

            //If no item is selected in route, open particular item on the basis of status of recently accessed item
            if (! (this.route.firstChild && this.route.firstChild.snapshot.params.itemId)) {
                if (this.productTocData.toc.navigationMeta && this.productTocData.toc.navigationMeta.length > 0) {
                    let itemid;
                    //NavigationArray : array containing all resources
                    let navigationArray = this.productTocData.toc.navigationMeta;
                    //Check the most recently accessed Item stored in State API if user is not a teacher
                    let recentlyAccessedItem;
                    if(this.appState && !this.assignmentId) {
                        // Recent item coresponding to class/product
                        recentlyAccessedItem = this.appState.recentlyAccessedItem;
                    }
                    
                    if(!this.isTeacher && recentlyAccessedItem) { 
                        //Find index of most recently accessed Item in NavigationArray
                        const recentlyAccessedItemIndex = navigationArray.map(
                            (val) => val["item-code"]).indexOf(recentlyAccessedItem);
                        // In case the book gets updated, the last stored recentlyAccessedItem is 
                        // no longer in the new book structure then open the first index item in the book
                        if (recentlyAccessedItemIndex === -1) {
                            itemid = navigationArray[0]["item-code"];
                        } else {
                            // If status of most recently accessed Item is completed and it is not the last item of product
                            // and it is non downloadable LO , Launch the next item/LO
                            if (recentlyAccessedItemIndex !== (navigationArray.length - 1) &&
                             navigationArray[recentlyAccessedItemIndex] &&  navigationArray[recentlyAccessedItemIndex].__analytics 
                             && navigationArray[recentlyAccessedItemIndex].__analytics.status == 'completed' 
                             && !(ContentHelper.isDownloadableContent(navigationArray[recentlyAccessedItemIndex])) ) {
                                itemid = navigationArray[recentlyAccessedItemIndex + 1]["item-code"];                             
                            } else { //In all other cases launch the most recently accessed Item
                                itemid = recentlyAccessedItem;
                            }    
                        }   
                    } else { //If API does not return any item or user is a teacher, Launch first resource in TOC
                        itemid = navigationArray[0]["item-code"];
                    }
                    this.navigateToChild(itemid);     
                }
            } else {
                // Find which unit to be set to active
                this.findUnitSelected(decodeURIComponent(params.itemId || this.route.firstChild.snapshot.params.itemId));
            }

            //important, subscribe and handle change in item 
            this.selectedItemSubscription = this.activityViewHelperService.selectedItemId.subscribe(
                (selectedItemObject: any) => {
                if (this.selectedItem && this.selectedItem.activityId &&
                    this.activityViewHelperService.existsActivityTiming(this.selectedItem.activityId)) {
                    this.activityViewHelperService.addActivityTiming(this.selectedItem.activityId, 'gotNextItem');
                }
                // Hide all activity buttons by default when new activity launches
                this.showControls = [];

                this.selectedItem = selectedItemObject.selectedItem;
                this.selectedItemData = selectedItemObject.selectedItemData;
                this.findUnitSelected(selectedItemObject.itemid);

                // Show Next button immediately in download type activities
                setTimeout(()=> {
                    if (this.selectedItemData['accessInfo'].isLocked) {
                        this.showOrHideNextActivityButton();
                    } else {
                        var unitId = this.selectedItem.unitId;
                        var lessonId = this.selectedItem.lessonId;
                        var activityId = this.selectedItem.activityId;
                        var courseToc = this.productTocData.toc.tocObject;

                        this.isGameActivity = courseToc[unitId].items[lessonId].items[activityId]['game'] ? true : false;

                        if (ContentHelper.isDownloadableContent(courseToc[unitId].items[lessonId].items[activityId])) {
                            // Do not show next button in case Downloadable activity is the last activity of the product
                            this.showOrHideNextActivityButton();
                        } else if( !this.isTeacher && ContentHelper.isCollaborativeTask(courseToc[unitId].items[lessonId].items[activityId]) && courseToc[unitId].items[lessonId].items[activityId].__analytics.completedOnce) {
                            this.showOrHideNextActivityButton();
                        } else if( !this.isTeacher && ContentHelper.isSubmittableContent(courseToc[unitId].items[lessonId].items[activityId])  && courseToc[unitId].items[lessonId].items[activityId].__analytics && courseToc[unitId].items[lessonId].items[activityId].__analytics.submittedOnce && 
                            (!courseToc[unitId].items[lessonId].items[activityId].__analytics['reattempt-requested'] || courseToc[unitId].items[lessonId].items[activityId].__analytics.submitCount >= 3)){
                            this.showOrHideNextActivityButton();
                        } else if (this.isTeacher && (ContentHelper.isSubmittableContent(courseToc[unitId].items[lessonId].items[activityId]) || ContentHelper.isCollaborativeTask(courseToc[unitId].items[lessonId].items[activityId]))) {
                            this.showOrHideNextActivityButton();
                        } else {
                            this.showNextActivityBtn = false;
                        }
                    }
                    
                });                
            });
            
            if (this.userProfileData && this.userProfileData.role === 'student' && this.userProfileData.launchType !== 'lti') {
                try {
                    // logging product viewed event
                    const userData = {
                        user: this.userProfileData,
                        productCode: this.productCode,
                        classId: this.classId,
                        assignmentId: this.assignmentId,
                        spaceId: this.spaceId,
                        itemId: params.itemId || this.route.firstChild.snapshot.params.itemId,
                        page: this.trackUserService.CONSTANTS.NAVIGATED_PAGE_NAMES.NLP_ACTIVITY
                    }
                    const loginEvent = this.trackUserService.generateProductViewedEvent(userData);
                    this.trackUserService.logEvents([loginEvent]);
                }
                catch (e) {
                    // do nothing just logging
                    console.log(e);
                }
            }
        });
    }

    /**
     * sets next activity button if not last item
     */
    showOrHideNextActivityButton(){
        let navigationArray = this.productTocData.toc.navigationMeta;
        let currentItemIndex = navigationArray.map( (val) => val["item-code"] ).indexOf(this.selectedItem.activityId);
        if ( currentItemIndex !== navigationArray.length-1) {
            this.showNextActivityBtn = true;
        } else {
            this.showNextActivityBtn = false;
        }      
    }

    findUnitSelected (itemid): void {
        let unitid = itemid.split('/')[0];
        for(var index=0; this.tocArray.result && index<this.tocArray.result.length; index++) {            
            if (this.tocArray.result[index]['item-code'] === unitid) {
                this.selectedItem.selectedUnitIndex = index;
                break;
            }
        }
    }

    navigateToChild(itemid) {
        let navigateToArray = ["item", itemid];

        let navigationArray = this.productTocData.toc.navigationMeta;
        let item = navigationArray.find((items)=> {
            return items['item-code'] === itemid;
        })
        // This will send teacher to group selection page only when opened from Materials page of the a class with groups because only then will the navigationArray have the collab items in it
        if(item && ContentHelper.isCollaborativeTask(item) && this.isTeacher && this.classId) {
            // Send to group selection page only if groups exist in a class
            const groups = this.groupHelperService.getGroups();
            if(groups && groups.length > 0) {
                navigateToArray.push("group-selection");
                navigateToArray.unshift("../");
                this.loaderService.showOverlayLoader();
            }
        }
        if(this.previewMode) {
            this.router.navigate(navigateToArray, { relativeTo: this.route, queryParams: { preview: true }, replaceUrl: true});
        } else {
            let requiredQueryParams = this.appHelperService.getRequiredQueryParams(this.route.snapshot.queryParams, ['lf', 'cid', 'bcode', 'rcode', 'ltik', 'b']);
            this.router.navigate(navigateToArray, { relativeTo: this.route, replaceUrl: true, queryParams: requiredQueryParams });
        }
    }

    /* Function to action content controls - checkAnswer/goNext/goToExerciseScreen/sendScores */
    actionControl({containerType, type}) {
        // hide C1 result screen if rendered 
        this.hideResultScreen();

        if(type === 'goToExerciseScreen' || type === 'reviewAnswers' || type === 'goPrev') {
            this.showNextActivityBtn = false;
        }

        // Action Control
        this.activityViewHelperService.getXAPIRunnerObject().containerInvocation(this.selectedItem.activityId, containerType, {type});
    }

    isThisLastActivityOfUnit() {
      if ( this.isTeacher ) {
        return false;
      }
      const unit = this.productTocData.toc.tocArray.result.find( (u) => ( u['item-code'] === this.selectedItem.unitId) );
      let activityCounter = 1;
      let lessonCounter = 1;
      let lesson = unit.items[unit.items.length - lessonCounter];
      let activity = lesson.items[ lesson.items.length - activityCounter];
      // safe check for lesson with no activities
      while ( !activity ) {
        activityCounter++;
        if (activityCounter > lesson.items.length) {
          activityCounter = 1;
          lessonCounter++;
          if (lessonCounter > unit.items.length) {
            // In extreme case, return true, so that user will be taken back to TOC
            return true;
          }
          lesson = unit.items[unit.items.length - lessonCounter];
        }
        // this activity can be undefined, if a lesson has no activities
        activity = lesson.items[ lesson.items.length - activityCounter ];
      }
      return activity['item-code'] === this.selectedItem.activityId;
    }

    nextActivity() {
        if (!this.showNextActivityBtn) {
            // Safe check to prevent user from using the btn in hidden state
            return;
        }
        this.loaderService.showOverlayLoader();
        // following unit related logic is applicable for non assignment work only
        if (!this.assignmentId) {
            const isUnitComplete = this.activityViewHelperService.isThisUnitComplete(this.selectedItem.unitId);
            // Close and Go back to TOC, if -
            //      this is unit's last activity
            // OR   this unit's completion is not animated and unit is complete
            if ( this.isThisLastActivityOfUnit() || ( (!this.appState || !this.appState.animatedUnitCompletion || !this.appState.animatedUnitCompletion[this.selectedItem.unitId] ) && isUnitComplete )) {
                this.activityViewHelperService.closeActivitySubject.next();
                return;
            // For an edge case, when user uses launches activity without using TOC
            } else if (this.appState && this.appState.animatedUnitCompletion && this.appState.animatedUnitCompletion[this.selectedItem.unitId] && !isUnitComplete) {
                this.appState.animatedUnitCompletion[this.selectedItem.unitId] = false;
                this.activityViewDataService.updateAppState(this.spaceId, this.productCode, this.appState, this.classId).subscribe();
            }
        }
        let navigationArray = this.productTocData.toc.navigationMeta;
        let currentItemIndex = navigationArray.map( (val) => val["item-code"] ).indexOf(this.selectedItem.activityId);
        // Check if next button was pressed on last activity
        if (currentItemIndex !== navigationArray.length-1 && navigationArray[currentItemIndex+1]) {
            this.navigateToChild(navigationArray[currentItemIndex+1]['item-code']);
        } else {
            this.activityViewHelperService.closeActivitySubject.next();
        }       
    }

    // Function to hide C1 rendered result screen
    hideResultScreen() {
        if (this.showResultScreen) {
            this.showResultScreen = false;
        }
    }
    
    // Function to relaunch activity
    relaunchActivity() {
        this.showControls = [];
        this.showNextActivityBtn = false;
        this.activityViewHelperService.getXAPIRunnerObject().reLaunchLO(this.selectedItem.activityId);
    }

    /* Function to return true for all control types for which control needs to be shown in green */
    isControlToBeShownGreen(type) {
        switch (type) {
            case 'checkAnswer':
            case 'goNext':
            case 'goToExerciseScreen':
            case 'sendScores':
            case 'checkAnswers':
            case 'reviewAnswers':
            case 'launchNextSPA':
            case 'sendScoresSPALO':
            case 'goPrev': return true;
            default: return false;
        }
    }

    canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
        return this.activityViewHelperService.terminateActivityView();
    }

    ngOnDestroy() {
        this.paramsSubscription.unsubscribe();
        this.selectedItemSubscription.unsubscribe();
        // Removed xapiLOAnalytics object so that no analytics call is made when user is leaves activity-view component
        this.xapiLOAnalytics = undefined;
    }

    //Formed Data to show in submitted pskill activity
    _getpSkillFormattedAnalyticData(subResData:any, courseToc:any) {
        let responseEntity;
        if (subResData && subResData.entities && subResData.entities[0]) {
            responseEntity = subResData.entities[0];
        }
        let analyticsData;
        if( responseEntity && responseEntity["item-code"]) {
            let decodedParamsArray = responseEntity["item-code"].split('/');
            let currentUnitId, currentLessonId, currentActivityId;
            currentUnitId = decodedParamsArray[0]
            currentLessonId = decodedParamsArray[0] + '/' + decodedParamsArray[1]
            currentActivityId = decodedParamsArray[0] + '/' + decodedParamsArray[1] + '/' + decodedParamsArray[2];
            if (currentUnitId && currentLessonId && currentActivityId) {
                courseToc[currentUnitId].items[currentLessonId].items[currentActivityId].__analytics.status = 'in_complete';
                courseToc[currentUnitId].items[currentLessonId].items[currentActivityId].__analytics.lastSubmitted = new Date().getTime();
                courseToc[currentUnitId].items[currentLessonId].items[currentActivityId].__analytics.submittedOnce = true;
                if (responseEntity.result && responseEntity.result.response && responseEntity.result.response.text) {
                    analyticsData={ text : responseEntity.result.response.text };
                    if (responseEntity.result.response.attribs && responseEntity.result.response.attribs.title) {
                        analyticsData['attribs'] = {
                            'title': responseEntity.result.response.attribs.title
                        };
                    }
                    if (responseEntity.result.response.link) {
                        analyticsData['link'] = responseEntity.result.response.link;
                    }
                }
                if (responseEntity.result && responseEntity.result.response && responseEntity.result.response.audioPath) {
                    analyticsData={ audioPath : responseEntity.result.response.audioPath };
                }
                // Update the icon object
                this.updateLCHObjects(courseToc[currentUnitId].items[currentLessonId].items[currentActivityId]);
            }
        }
        return analyticsData;
    }
    
    /* Function to update 'libs-content-helper' icon object */
    updateLCHObjects(activity){
        this.activityViewHelperService.getProductContentHelper().updateAnalyticsAsPerClassCustomisations(activity);
        activity.lchObject.iconObj = this.activityViewHelperService.getProductContentHelper().getActivityIconForNLP(activity);
    }

    private logInfoToBackend(context: string, data: any = {}) {
        this.customBackendLoggerService.logInfoToBackend({
            context,
            extUserId: this.userProfileData.extUserId,
            spaceId: this.spaceId,
            classId: this.classId,
            productCode: this.productCode,
            data: {
                itemCode: this.selectedItem.activityId,
                ...data
            },
            isUserInfoNeeded: true,
        }).toPromise();
    }

    private analyzeLocalStorage(errorObject) {
        try {
            if (!errorObject || errorObject.name !== 'QuotaExceededError') {
                return {};
            }
            return Object.keys(window.localStorage).reduce((acc, key) => {
                const s = key.length + window.localStorage.getItem(key).length;
                acc.lsKeys.push({ k: key, s });
                acc.lsTotal += s;
                return acc;
            }, { lsTotal: 0, lsKeys: [] });
        } catch (err) {
            return { lsError: err.message || err };
        }
    }
}
